import Loadable from '@townsquare/loadable';

export const SharedConversationPreviewLoadable = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "shared-conversation-preview-view" */ './SharedConversationPreviewView'
		),
	loading: () => null,
});
